(function() {
	'use strict';

	angular
		.module('pwc.utils')
		.service('Utils', Utils);

	Utils.$inject = ['$window', '$log', 'lodash', '$state'];

	function Utils($window, $log, lodash, $state) {

		/* jshint validthis: true */
		var self = this;

		var userAgent = $window.navigator.userAgent;

		$log.debug('UA', userAgent);

		self.agent = {
			isIOS: function(){
				return /iP(hone|ad|od)/.test(userAgent);
			},
			isIOSChrome: function(){
				return userAgent.match("CriOS");
			},
			iOSVersion: function(){
                var v = ($window.navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
                return lodash.parseInt(v[1], 10);
			},
            isIOSChromeLte9: function(){
                return self.agent.isIOSChrome() && self.agent.iOSVersion() <= 9;
            },
			isOlderIOSSafari: function(){

				if (self.agent.isIOS() && userAgent.match(/WebKit/i) && self.agent.iOSVersion() <= 9){
					return true;
				}

				return false;
			}
		};

		self.isNumeric = isNumeric;
		self.go = go;
		self.goBack = goBack;
        self.formatCurrency = formatCurrency;
		self.formatCurrencyShort = formatCurrencyShort;
		self.camelCaseToWords = camelCaseToWords;

        function camelCaseToWords(s) {
            return s.split(/(?=[A-Z])/).map(function(p) {
                return p.charAt(0).toUpperCase() + p.slice(1);
            }).join(' ');
        }

        function go(state, params) {
            $state.go(state, params);
        }

    	function goBack(){
            $window.history.back();
        }

		function isNumeric(n){
			return ! isNaN(parseFloat(n)) && isFinite(n);
		}

        function formatCurrency(str){
            if (lodash.isEmptyOrNull(str)){
                return null;
            }

            return $window.numeral(str).format('$0,0.00');
        }

        function formatCurrencyShort(str){
            if (lodash.isEmptyOrNull(str)){
                return null;
            }

            return $window.numeral(str).format('$0,0[.]00');
        }
	}

})();
